import { render, staticRenderFns } from "./ParticaDialogCard.vue?vue&type=template&id=a9e2977c&scoped=true&"
import script from "./ParticaDialogCard.vue?vue&type=script&lang=ts&"
export * from "./ParticaDialogCard.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaDialogCard.vue?vue&type=style&index=0&id=a9e2977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e2977c",
  null
  
)

export default component.exports